import { useState } from 'react'
import { useAuth } from '@clerk/clerk-react'
import useSWR from 'swr'
import { AlbumGrid } from '@/components/album/AlbumGrid'
import { AlbumFilter } from '@/components/album/AlbumFilter'

export function AlbumPage() {
  const { getToken } = useAuth()
  const [filter, setFilter] = useState({ query: '', genre: '', mediaType: '', sortBy: 'view_count' })

  const { data, error, isLoading } = useSWR(
    ['/api/v1/titles', filter],
    async ([url, filter]) => {
      const token = await getToken()
      const params = new URLSearchParams()
      if (filter.query) params.set('q', filter.query)
      if (filter.genre) params.set('genre', filter.genre)
      if (filter.mediaType) params.set('mediaType', filter.mediaType)
      if (filter.sortBy) params.set('sortBy', filter.sortBy)

      const queryString = params.toString()
      const fetchUrl = `${url}?${queryString}`

      const res = await fetch(fetchUrl, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      return res.json()
    }
  )

  const titles = data?.titles || []
  const total = data?.total

  if (error) {
    return (
      <div className="text-center py-10">
        <p className="text-red-500">エラーが発生しました</p>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-3xl font-bold">視聴アルバム</h2>
        {total !== undefined && (
          <p className="text-muted-foreground">
            {total}作品
          </p>
        )}
      </div>

      <AlbumFilter filter={filter} onFilterChange={setFilter} />

      {isLoading ? (
        <div className="text-center py-20">
          <p className="text-muted-foreground">読み込み中...</p>
        </div>
      ) : titles && titles.length > 0 ? (
        <AlbumGrid titles={titles} />
      ) : (
        <div className="text-center py-20">
          <p className="text-muted-foreground">
            まだ視聴データがありません。CSVをアップロードしてください。
          </p>
        </div>
      )}
    </div>
  )
}
